export const MAX_SEARCH_RESULTS_COUNT = 10;
export const MIN_QUERY_LENGTH = 1;
export const SEARCH_DEBOUNCE_MS = 300;
export const MAX_OPTION_SEARCH_RESULTS = 500;
export const SEARCH_INDEX_CHUNK_SIZE = 1000;
